import { Component, EventEmitter, Input, OnChanges, Output, ViewEncapsulation } from '@angular/core';
import { ProcessEntry } from '../../interfaces/screen-actions.interface';
import { TableConfig } from '../table/interfaces/table-config.interface';

@Component({
  selector: 'data-view-list-element-menu',
  templateUrl: 'data-view-list-element-menu.html',
  styles: ['data-view-list-element-menu.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class DataViewListElementMenu implements OnChanges {
  screenActions: { processList: ProcessEntry[] } = {
    processList: [],
  };

  @Input() config: TableConfig;
  @Output() optionAction = new EventEmitter<ProcessEntry>();

  constructor() {}

  ngOnChanges(): void {
    this.initializeMenu();
  }

  private initializeMenu() {
    this.screenActions = {
      processList: this.config.screenActions.processList.filter(process => process.contextMenuVisible)
    }
  }

  onClick(index: number) {
    this.optionAction.emit(this.screenActions.processList[index]);
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/components/data-view-list-element-menu/data-view-list-element-menu.ts